// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Item-module__font-s-10___V3Pbv {
  font-size: 10px !important;
}

.Item-module__font-s-12___D9XUV {
  font-size: 12px !important;
}

.Item-module__font-s-13___O2htN {
  font-size: 13px !important;
}

.Item-module__font-s-14___uvcYE {
  font-size: 14px !important;
}

.Item-module__font-s-15___nKQck {
  font-size: 15px !important;
}

.Item-module__font-s-16___G6fmt {
  font-size: 16px !important;
}

.Item-module__font-s-18___e6sto {
  font-size: 18px !important;
}

.Item-module__font-s-20___ZZoik {
  font-size: 20px !important;
}

.Item-module__font-s-22___O520p {
  font-size: 22px !important;
}

.Item-module__font-s-28___bvTep {
  font-size: 28px !important;
}

.Item-module__font-w-400___HtnN2 {
  font-weight: 400 !important;
}

.Item-module__font-w-500___b4VUt {
  font-weight: 500 !important;
}

.Item-module__font-w-600___SLdTd {
  font-weight: 600 !important;
}

.Item-module__font-w-700___FTtRN {
  font-weight: 700 !important;
}

.Item-module__p-5___IQRvD {
  padding: 5px !important;
}

.Item-module__p-12___qZavA {
  padding: 12px !important;
}

.Item-module__p-16___eMjfi {
  padding: 16px !important;
}

.Item-module__p-30___xRdO7 {
  padding: 30px !important;
}

.Item-module__p-b-0___TTJT5 {
  padding-bottom: 0 !important;
}

.Item-module__p-b-5___SyzuX {
  padding-bottom: 5px !important;
}

.Item-module__p-b-10___jpnFJ {
  padding-bottom: 10px !important;
}

.Item-module__p-b-12___p6jEw {
  padding-bottom: 12px !important;
}

.Item-module__p-b-16___huCEc {
  padding-bottom: 16px !important;
}

.Item-module__p-b-18___rHRX2 {
  padding-bottom: 18px !important;
}

.Item-module__p-b-20___Mokhl {
  padding-bottom: 20px !important;
}

.Item-module__p-b-25___zTbyr {
  padding-bottom: 25px !important;
}

.Item-module__p-b-30___Iv2us {
  padding-bottom: 30px !important;
}

.Item-module__p-b-50___UG2ud {
  padding-bottom: 50px !important;
}

.Item-module__p-t-0___B6GXC {
  padding-top: 0 !important;
}

.Item-module__p-t-12___iesR5 {
  padding-top: 12px !important;
}

.Item-module__p-t-16___wQnxH {
  padding-top: 16px !important;
}

.Item-module__p-t-18___sY0i0 {
  padding-top: 18px !important;
}

.Item-module__p-t-20___tfPl_ {
  padding-top: 20px !important;
}

.Item-module__p-t-30___f3bwn {
  padding-top: 30px !important;
}

.Item-module__p-t-40___U9q8U {
  padding-top: 40px !important;
}

.Item-module__p-t-50___HWSyM {
  padding-top: 50px !important;
}

.Item-module__p-l-20___Exy0b {
  padding-left: 20px !important;
}

.Item-module__p-l-30___wRJXS {
  padding-left: 30px !important;
}

.Item-module__p-l-40___HCamA {
  padding-left: 40px !important;
}

.Item-module__p-r-16___WGvSX {
  padding-right: 16px !important;
}

.Item-module__p-r-20___PEKaf {
  padding-right: 20px !important;
}

.Item-module__p-r-30___OaWOc {
  padding-right: 30px !important;
}

.Item-module__p-r-50___mEIsf {
  padding-right: 50px !important;
}

.Item-module__p-r-60___HpE8t {
  padding-right: 60px !important;
}

.Item-module__m-b-1___c5ZEB {
  margin-bottom: 1px !important;
}

.Item-module__m-b-2___BWvS2 {
  margin-bottom: 2px !important;
}

.Item-module__m-b-6___pS7AV {
  margin-bottom: 6px !important;
}

.Item-module__m-b-8___gW0h8 {
  margin-bottom: 8px !important;
}

.Item-module__m-b-10___Pe7Q9 {
  margin-bottom: 10px !important;
}

.Item-module__m-b-14___Ck6Dg {
  margin-bottom: 14px !important;
}

.Item-module__m-b-16___dItDL {
  margin-bottom: 16px !important;
}

.Item-module__m-b-20___LIodn {
  margin-bottom: 20px !important;
}

.Item-module__m-b-22___LaaIk {
  margin-bottom: 22px !important;
}

.Item-module__m-b-24___XFK29 {
  margin-bottom: 24px !important;
}

.Item-module__m-b-30____fB9X {
  margin-bottom: 30px !important;
}

.Item-module__m-b-32___MtZ6q {
  margin-bottom: 32px !important;
}

.Item-module__m-b-40___PyoXf {
  margin-bottom: 40px !important;
}

.Item-module__m-t-2___ng4Kk {
  margin-top: 2px !important;
}

.Item-module__m-t-3___NxTxz {
  margin-top: 3px !important;
}

.Item-module__m-t-4___Xe47J {
  margin-top: 4px !important;
}

.Item-module__m-t-5___uHLmV {
  margin-top: 5px !important;
}

.Item-module__m-t-8___y1P1p {
  margin-top: 8px !important;
}

.Item-module__m-t-10___T00K8 {
  margin-top: 10px !important;
}

.Item-module__m-t-15___oxBLc {
  margin-top: 15px !important;
}

.Item-module__m-t-16___b8rAk {
  margin-top: 16px !important;
}

.Item-module__m-t-20___v8At2 {
  margin-top: 20px !important;
}

.Item-module__m-t-22___y3Gar {
  margin-top: 22px !important;
}

.Item-module__m-t-30___WqdUQ {
  margin-top: 30px !important;
}

.Item-module__m-t-32___O73_u {
  margin-top: 32px !important;
}

.Item-module__m-l-auto___ZHpLx {
  margin-left: auto !important;
}

.Item-module__m-l-4___iZNVI {
  margin-left: 4px !important;
}

.Item-module__m-l-5___gt55s {
  margin-left: 5px !important;
}

.Item-module__m-l-6___yFyAS {
  margin-left: 6px !important;
}

.Item-module__m-l-8___pmEkP {
  margin-left: 8px !important;
}

.Item-module__m-l-10___mkR_k {
  margin-left: 10px !important;
}

.Item-module__m-l-16___xNYnf {
  margin-left: 16px !important;
}

.Item-module__m-l-20___MSuJ_ {
  margin-left: 20px !important;
}

.Item-module__m-l-24___dCxmb {
  margin-left: 24px !important;
}

.Item-module__m-l-30___FSNPG {
  margin-left: 30px !important;
}

.Item-module__m-l-35___K_bmw {
  margin-left: 35px !important;
}

.Item-module__m-l-40___haMhH {
  margin-left: 40px !important;
}

.Item-module__m-r-8___yMA7y {
  margin-right: 8px !important;
}

.Item-module__m-r-10___Ezuop {
  margin-right: 10px !important;
}

.Item-module__m-r-16___haDON {
  margin-right: 16px !important;
}

.Item-module__m-r-20___CU9Hj {
  margin-right: 20px !important;
}

.Item-module__m-r-24___S0EBf {
  margin-right: 24px !important;
}

.Item-module__m-r-30___RRx0c {
  margin-right: 30px !important;
}

.Item-module__m-r-40___rltpN {
  margin-right: 40px !important;
}

.Item-module__border-r-3___eHcEf {
  border-radius: 3px !important;
}

.Item-module__border-r-4___GNc2p {
  border-radius: 4px !important;
}

.Item-module__border-r-6___qu9fW {
  border-radius: 6px !important;
}

.Item-module__border-r-10___oYGUo {
  border-radius: 10px !important;
}

.Item-module__border-r-12___rCmON {
  border-radius: 12px !important;
}

.Item-module__border-r-16___v6PHD {
  border-radius: 16px !important;
}

.Item-module__border-r-50___wvRWn {
  border-radius: 50% !important;
}

.Item-module__primary-border___RRsiP {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-b___OOPWT {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-t___cGhXf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-l___cW24E {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-r___N4k16 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__secondary-border___cqZSN {
  border: 1px solid #637768;
}

.Item-module__secondary-border-b___G7RqB {
  border-bottom: 1px solid #637768;
}

.Item-module__secondary-border-t___ETVv3 {
  border-top: 1px solid #637768;
}

.Item-module__secondary-border-l___g1CW9 {
  border-left: 1px solid #637768;
}

.Item-module__secondary-border-r___junwB {
  border-right: 1px solid #637768;
}

.Item-module__gap-0___rBHfX {
  gap: 0 !important;
}

.Item-module__gap-2___ql8jI {
  gap: 2px !important;
}

.Item-module__gap-4___oao0u {
  gap: 4px !important;
}

.Item-module__gap-5___tLH1u {
  gap: 5px !important;
}

.Item-module__gap-6___Lhu_C {
  gap: 6px !important;
}

.Item-module__gap-8___nxHfP {
  gap: 8px !important;
}

.Item-module__gap-10___GnRl_ {
  gap: 10px !important;
}

.Item-module__gap-12___d2MBX {
  gap: 12px !important;
}

.Item-module__gap-14___xX7lh {
  gap: 14px !important;
}

.Item-module__gap-16___N_4MF {
  gap: 16px !important;
}

.Item-module__gap-18___gbd1L {
  gap: 18px !important;
}

.Item-module__gap-20___YtrjU {
  gap: 20px !important;
}

.Item-module__gap-24___esM3S {
  gap: 24px !important;
}

.Item-module__gap-26___FjCiE {
  gap: 26px !important;
}

.Item-module__gap-30___Kp5j0 {
  gap: 30px !important;
}

.Item-module__gap-32___Uvn5K {
  gap: 32px !important;
}

.Item-module__gap-40___EDuoZ {
  gap: 40px !important;
}

.Item-module__gap-50___xxjBT {
  gap: 50px !important;
}

.Item-module__flex-1___gQgez {
  flex: 1;
}

.Item-module__flex-none___VRtN3 {
  flex: none !important;
}

.Item-module__flex-column___PWiGn {
  display: flex;
  flex-direction: column !important;
}

.Item-module__flex-row___u1YPq {
  display: flex;
  flex-direction: row !important;
}

.Item-module__vertically-centered___jmOqX {
  display: flex;
  align-items: center !important;
}

.Item-module__horizontally-centered___WgTcL {
  display: flex;
  justify-content: center !important;
}

.Item-module__horizontally-end___Qmiia {
  display: flex;
  justify-content: end !important;
}

.Item-module__vertically-start___T5lIT {
  display: flex;
  align-items: start !important;
}

.Item-module__space-between___Gwoau {
  display: flex;
  justify-content: space-between !important;
}

.Item-module__flex-wrap___kdYet {
  flex-wrap: wrap !important;
}

.Item-module__height-100___qhaoh {
  height: 100%;
}

.Item-module__width-50___idADW {
  width: 50% !important;
}

.Item-module__width-100___qTJ3B {
  width: 100%;
}

.Item-module__cursor-pointer___jxTRJ {
  cursor: pointer;
}

.Item-module__cursor-not-allowed___tdhbf {
  cursor: not-allowed !important;
}

.Item-module__absolute-centered___tg7Hu {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Item-module__absolute___qGPwl {
  position: absolute;
}

.Item-module__relative___SjGrq {
  position: relative;
}

.Item-module__fixed___ypr5U {
  position: fixed;
}

.Item-module__visible___CYBi1 {
  opacity: 1;
}

.Item-module__invisible___qs6Mo {
  opacity: 0;
}

.Item-module__col-90___Osv53 {
  width: 90% !important;
}

.Item-module__col-auto___pFqC6 {
  width: auto !important;
}

.Item-module__medical-tabs___zAQqc {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Item-module__medical-table-new___PWmUH {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___PWmUH:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___PWmUH::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___PWmUH::-webkit-scrollbar-track {
  display: none;
}
.Item-module__medical-table-new___PWmUH.Item-module__no-pagination____mMQt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___PWmUH.Item-module__no-pagination____mMQt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___PWmUH.Item-module__no-pagination____mMQt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___PWmUH.Item-module__no-pagination____mMQt::-webkit-scrollbar-track {
  display: none;
}

.Item-module__medical-table-empty___JPHEq {
  padding: 14px 40px !important;
}

.Item-module__icon-btn___zi0jL {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Item-module__search-icon___zZ2QK {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Item-module__disable-select___ySO9R {
  user-select: none;
}

.Item-module__break-word___Od0PW {
  word-break: break-word;
}

.Item-module__popup-clear-btn___Fd4ML {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Item-module__scroll-m-b-20___Q49MQ {
  scroll-margin-bottom: 20px;
}

.Item-module__container___jnj5I {
  display: flex;
  flex: 1;
  align-items: flex-start;
  padding: 12px 36px 12px 16px;
  background-color: #fdfcfa;
  border-radius: 12px;
  margin: 8px 35px 0 35px;
}
.Item-module__container___jnj5I .Item-module__icon___heURz {
  width: 34px;
  height: 34px;
}
.Item-module__container___jnj5I .Item-module__textContainer___boqaQ {
  flex: 1;
}
.Item-module__container___jnj5I .Item-module__textContainer___boqaQ .Item-module__orderedBy___W2wUJ {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #a79988;
}
.Item-module__container___jnj5I .Item-module__textContainer___boqaQ .Item-module__date___Ohvtg {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 19px;
  color: #375844;
}
.Item-module__container___jnj5I .Item-module__textContainer___boqaQ .Item-module__number___e0f8D {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #637768;
}
.Item-module__container___jnj5I .Item-module__button___nlFWw {
  align-self: center;
  padding: 6px 8px;
  border-radius: 33px;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 17px;
  color: #375844;
  cursor: pointer;
}
.Item-module__container___jnj5I .Item-module__button___nlFWw .Item-module__shippingIcon___Rd1za {
  height: 13px;
  width: 12px;
}
.Item-module__container___jnj5I .Item-module__menu___UdmR8 {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DevicesFragment/components/OrderHistoryList/Item/Item.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,OAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,OAAA;AA6pBJ;AA3pBI;EEOF,+BApBO;EAqBP,gBAFmD;EFJ/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EECF,+BApBO;EAqBP,gBAFmD;EFE/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EELF,+BApBO;EAqBP,gBAFmD;EFQ/C,iBAAA;EACA,cAAA;AA8pBN;AA1pBE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EEfF,+BApBO;EAqBP,gBAFmD;EFkBjD,iBAAA;EACA,cAAA;EACA,eAAA;AA6pBJ;AA3pBI;EACE,YAAA;EACA,WAAA;AA6pBN;AAzpBE;EACE,kBAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  padding: 12px 36px 12px 16px;\n  background-color: get-color(grayNew, ultra-light);\n  border-radius: 12px;\n  margin: 8px 35px 0 35px;\n\n  .icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .textContainer {\n    flex: 1;\n\n    .orderedBy {\n      @include get-font($roboto);\n      line-height: 150%;\n      color: #a79988;\n    }\n\n    .date {\n      @include get-font($roboto);\n      line-height: 19px;\n      color: get-color(greenNew, dark);\n    }\n\n    .number {\n      @include get-font($roboto);\n      line-height: 15px;\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n\n  .button {\n    align-self: center;\n    padding: 6px 8px;\n    border-radius: 33px;\n    @include get-font($roboto);\n    line-height: 17px;\n    color: get-color(greenNew, dark);\n    cursor: pointer;\n\n    .shippingIcon {\n      height: 13px;\n      width: 12px;\n    }\n  }\n\n  .menu {\n    align-self: center;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Item-module__font-s-10___V3Pbv`,
	"fontS12": `Item-module__font-s-12___D9XUV`,
	"fontS13": `Item-module__font-s-13___O2htN`,
	"fontS14": `Item-module__font-s-14___uvcYE`,
	"fontS15": `Item-module__font-s-15___nKQck`,
	"fontS16": `Item-module__font-s-16___G6fmt`,
	"fontS18": `Item-module__font-s-18___e6sto`,
	"fontS20": `Item-module__font-s-20___ZZoik`,
	"fontS22": `Item-module__font-s-22___O520p`,
	"fontS28": `Item-module__font-s-28___bvTep`,
	"fontW400": `Item-module__font-w-400___HtnN2`,
	"fontW500": `Item-module__font-w-500___b4VUt`,
	"fontW600": `Item-module__font-w-600___SLdTd`,
	"fontW700": `Item-module__font-w-700___FTtRN`,
	"p5": `Item-module__p-5___IQRvD`,
	"p12": `Item-module__p-12___qZavA`,
	"p16": `Item-module__p-16___eMjfi`,
	"p30": `Item-module__p-30___xRdO7`,
	"pB0": `Item-module__p-b-0___TTJT5`,
	"pB5": `Item-module__p-b-5___SyzuX`,
	"pB10": `Item-module__p-b-10___jpnFJ`,
	"pB12": `Item-module__p-b-12___p6jEw`,
	"pB16": `Item-module__p-b-16___huCEc`,
	"pB18": `Item-module__p-b-18___rHRX2`,
	"pB20": `Item-module__p-b-20___Mokhl`,
	"pB25": `Item-module__p-b-25___zTbyr`,
	"pB30": `Item-module__p-b-30___Iv2us`,
	"pB50": `Item-module__p-b-50___UG2ud`,
	"pT0": `Item-module__p-t-0___B6GXC`,
	"pT12": `Item-module__p-t-12___iesR5`,
	"pT16": `Item-module__p-t-16___wQnxH`,
	"pT18": `Item-module__p-t-18___sY0i0`,
	"pT20": `Item-module__p-t-20___tfPl_`,
	"pT30": `Item-module__p-t-30___f3bwn`,
	"pT40": `Item-module__p-t-40___U9q8U`,
	"pT50": `Item-module__p-t-50___HWSyM`,
	"pL20": `Item-module__p-l-20___Exy0b`,
	"pL30": `Item-module__p-l-30___wRJXS`,
	"pL40": `Item-module__p-l-40___HCamA`,
	"pR16": `Item-module__p-r-16___WGvSX`,
	"pR20": `Item-module__p-r-20___PEKaf`,
	"pR30": `Item-module__p-r-30___OaWOc`,
	"pR50": `Item-module__p-r-50___mEIsf`,
	"pR60": `Item-module__p-r-60___HpE8t`,
	"mB1": `Item-module__m-b-1___c5ZEB`,
	"mB2": `Item-module__m-b-2___BWvS2`,
	"mB6": `Item-module__m-b-6___pS7AV`,
	"mB8": `Item-module__m-b-8___gW0h8`,
	"mB10": `Item-module__m-b-10___Pe7Q9`,
	"mB14": `Item-module__m-b-14___Ck6Dg`,
	"mB16": `Item-module__m-b-16___dItDL`,
	"mB20": `Item-module__m-b-20___LIodn`,
	"mB22": `Item-module__m-b-22___LaaIk`,
	"mB24": `Item-module__m-b-24___XFK29`,
	"mB30": `Item-module__m-b-30____fB9X`,
	"mB32": `Item-module__m-b-32___MtZ6q`,
	"mB40": `Item-module__m-b-40___PyoXf`,
	"mT2": `Item-module__m-t-2___ng4Kk`,
	"mT3": `Item-module__m-t-3___NxTxz`,
	"mT4": `Item-module__m-t-4___Xe47J`,
	"mT5": `Item-module__m-t-5___uHLmV`,
	"mT8": `Item-module__m-t-8___y1P1p`,
	"mT10": `Item-module__m-t-10___T00K8`,
	"mT15": `Item-module__m-t-15___oxBLc`,
	"mT16": `Item-module__m-t-16___b8rAk`,
	"mT20": `Item-module__m-t-20___v8At2`,
	"mT22": `Item-module__m-t-22___y3Gar`,
	"mT30": `Item-module__m-t-30___WqdUQ`,
	"mT32": `Item-module__m-t-32___O73_u`,
	"mLAuto": `Item-module__m-l-auto___ZHpLx`,
	"mL4": `Item-module__m-l-4___iZNVI`,
	"mL5": `Item-module__m-l-5___gt55s`,
	"mL6": `Item-module__m-l-6___yFyAS`,
	"mL8": `Item-module__m-l-8___pmEkP`,
	"mL10": `Item-module__m-l-10___mkR_k`,
	"mL16": `Item-module__m-l-16___xNYnf`,
	"mL20": `Item-module__m-l-20___MSuJ_`,
	"mL24": `Item-module__m-l-24___dCxmb`,
	"mL30": `Item-module__m-l-30___FSNPG`,
	"mL35": `Item-module__m-l-35___K_bmw`,
	"mL40": `Item-module__m-l-40___haMhH`,
	"mR8": `Item-module__m-r-8___yMA7y`,
	"mR10": `Item-module__m-r-10___Ezuop`,
	"mR16": `Item-module__m-r-16___haDON`,
	"mR20": `Item-module__m-r-20___CU9Hj`,
	"mR24": `Item-module__m-r-24___S0EBf`,
	"mR30": `Item-module__m-r-30___RRx0c`,
	"mR40": `Item-module__m-r-40___rltpN`,
	"borderR3": `Item-module__border-r-3___eHcEf`,
	"borderR4": `Item-module__border-r-4___GNc2p`,
	"borderR6": `Item-module__border-r-6___qu9fW`,
	"borderR10": `Item-module__border-r-10___oYGUo`,
	"borderR12": `Item-module__border-r-12___rCmON`,
	"borderR16": `Item-module__border-r-16___v6PHD`,
	"borderR50": `Item-module__border-r-50___wvRWn`,
	"primaryBorder": `Item-module__primary-border___RRsiP`,
	"primaryBorderB": `Item-module__primary-border-b___OOPWT`,
	"primaryBorderT": `Item-module__primary-border-t___cGhXf`,
	"primaryBorderL": `Item-module__primary-border-l___cW24E`,
	"primaryBorderR": `Item-module__primary-border-r___N4k16`,
	"secondaryBorder": `Item-module__secondary-border___cqZSN`,
	"secondaryBorderB": `Item-module__secondary-border-b___G7RqB`,
	"secondaryBorderT": `Item-module__secondary-border-t___ETVv3`,
	"secondaryBorderL": `Item-module__secondary-border-l___g1CW9`,
	"secondaryBorderR": `Item-module__secondary-border-r___junwB`,
	"gap0": `Item-module__gap-0___rBHfX`,
	"gap2": `Item-module__gap-2___ql8jI`,
	"gap4": `Item-module__gap-4___oao0u`,
	"gap5": `Item-module__gap-5___tLH1u`,
	"gap6": `Item-module__gap-6___Lhu_C`,
	"gap8": `Item-module__gap-8___nxHfP`,
	"gap10": `Item-module__gap-10___GnRl_`,
	"gap12": `Item-module__gap-12___d2MBX`,
	"gap14": `Item-module__gap-14___xX7lh`,
	"gap16": `Item-module__gap-16___N_4MF`,
	"gap18": `Item-module__gap-18___gbd1L`,
	"gap20": `Item-module__gap-20___YtrjU`,
	"gap24": `Item-module__gap-24___esM3S`,
	"gap26": `Item-module__gap-26___FjCiE`,
	"gap30": `Item-module__gap-30___Kp5j0`,
	"gap32": `Item-module__gap-32___Uvn5K`,
	"gap40": `Item-module__gap-40___EDuoZ`,
	"gap50": `Item-module__gap-50___xxjBT`,
	"flex1": `Item-module__flex-1___gQgez`,
	"flexNone": `Item-module__flex-none___VRtN3`,
	"flexColumn": `Item-module__flex-column___PWiGn`,
	"flexRow": `Item-module__flex-row___u1YPq`,
	"verticallyCentered": `Item-module__vertically-centered___jmOqX`,
	"horizontallyCentered": `Item-module__horizontally-centered___WgTcL`,
	"horizontallyEnd": `Item-module__horizontally-end___Qmiia`,
	"verticallyStart": `Item-module__vertically-start___T5lIT`,
	"spaceBetween": `Item-module__space-between___Gwoau`,
	"flexWrap": `Item-module__flex-wrap___kdYet`,
	"height100": `Item-module__height-100___qhaoh`,
	"width50": `Item-module__width-50___idADW`,
	"width100": `Item-module__width-100___qTJ3B`,
	"cursorPointer": `Item-module__cursor-pointer___jxTRJ`,
	"cursorNotAllowed": `Item-module__cursor-not-allowed___tdhbf`,
	"absoluteCentered": `Item-module__absolute-centered___tg7Hu`,
	"absolute": `Item-module__absolute___qGPwl`,
	"relative": `Item-module__relative___SjGrq`,
	"fixed": `Item-module__fixed___ypr5U`,
	"visible": `Item-module__visible___CYBi1`,
	"invisible": `Item-module__invisible___qs6Mo`,
	"col90": `Item-module__col-90___Osv53`,
	"colAuto": `Item-module__col-auto___pFqC6`,
	"medicalTabs": `Item-module__medical-tabs___zAQqc`,
	"medicalTableNew": `Item-module__medical-table-new___PWmUH`,
	"noPagination": `Item-module__no-pagination____mMQt`,
	"medicalTableEmpty": `Item-module__medical-table-empty___JPHEq`,
	"iconBtn": `Item-module__icon-btn___zi0jL`,
	"searchIcon": `Item-module__search-icon___zZ2QK`,
	"disableSelect": `Item-module__disable-select___ySO9R`,
	"breakWord": `Item-module__break-word___Od0PW`,
	"popupClearBtn": `Item-module__popup-clear-btn___Fd4ML`,
	"scrollMB20": `Item-module__scroll-m-b-20___Q49MQ`,
	"container": `Item-module__container___jnj5I`,
	"icon": `Item-module__icon___heURz`,
	"textContainer": `Item-module__textContainer___boqaQ`,
	"orderedBy": `Item-module__orderedBy___W2wUJ`,
	"date": `Item-module__date___Ohvtg`,
	"number": `Item-module__number___e0f8D`,
	"button": `Item-module__button___nlFWw`,
	"shippingIcon": `Item-module__shippingIcon___Rd1za`,
	"menu": `Item-module__menu___UdmR8`
};
module.exports = ___CSS_LOADER_EXPORT___;
